import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ticketsActions from "../../redux/ticket/actions";
import { Button, notification, Input, Modal, Typography, Space } from "antd";
import { t } from "i18next";

const { Title, Text } = Typography;

const ConfirmEmailAndPhoneModal = ({ setShowSelectNewDate }) => {
  const dispatch = useDispatch();
  const { setOpenChangeTicketModel } = ticketsActions;
  const { singleTicketInfo, isChangeTicketModelOpen } = useSelector(
    (state) => state.ticketReducer
  );
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const checkUserInfo = () => {
    const isMatchFound = singleTicketInfo.some(
      (ticket) => ticket.email === userEmail || ticket.phone === userPhone
    );

    if (isMatchFound) {
      setUserEmail("");
      setUserPhone("");
      setShowSelectNewDate(true);
      dispatch(setOpenChangeTicketModel(false));
    } else {
      notification.error({
        message: t("wrongEmailOrPhone"),
        description: t("pleaseCheckAgainTicketNumber"),
        placement: "top",
      });
      setShowSelectNewDate(false);
    }
  };

  const handleCancel = () => {
    dispatch(setOpenChangeTicketModel(false));
  };

  return (
    <Modal
      footer={null}
      centered
      onCancel={handleCancel}
      title=""
      open={isChangeTicketModelOpen}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={2}>{t("confirmation")}</Title>
        <Text>{t("emailOrPhoneVerification")}</Text>

        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Text
            strong
            style={{
              display: "block",
              marginBottom: 8,
            }}
          >
            {t("emailFromTicket")}
          </Text>
          <Input
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            placeholder={t("email")}
            size="large"
          />
        </div>

        <div>
          <Text strong style={{ display: "block", marginBottom: 8 }}>
            {t("phoneFromTicket")}
          </Text>
          <Input
            value={userPhone}
            onChange={(e) => setUserPhone(e.target.value)}
            placeholder={t("phone")}
            size="large"
          />
        </div>

        <Button
          type="primary"
          className="custom-button"
          block
          size="large"
          style={{
            height: 50,
            marginTop: "10px",
          }}
          onClick={checkUserInfo}
        >
          {t("foundTicket")}
        </Button>
      </Space>
    </Modal>
  );
};

export default ConfirmEmailAndPhoneModal;
